<div
  class="flex flex-col md:flex-row py-4 content-center justify-between md:items-center"
>
  <p class="text-3xl">{{ greeting$ | async }}</p>
  <!--div class="flex items-center content-center gap-x-2 md:mt-0 mt-2">
    <p class="border font-medium px-1.5 py-0.5 rounded bg-surface flex">
      <soft-icon name="fa-regular fa-calendar pr-2"></soft-icon>
      {{ today$ | async | date: 'fullDate' : '' : 'de' }}
    </p>

    <p class="border font-medium px-1.5 py-0.5 rounded bg-surface flex min-w-[110px]">
      <soft-icon name="fa-regular fa-clock pr-2"></soft-icon>
      {{ today$ | async | date: 'HH:mm:ss' }}
    </p>
  </div-->
</div>
<!--div class="flex justify-between items-center gap-4">
  <soft-chip-group>
    <soft-chip>Dashboard 1</soft-chip>
    <soft-chip>Dashboard 2</soft-chip>
    <soft-chip>+</soft-chip>
  </soft-chip-group>
  <button class="soft-button accent flex rounded-md">
    <soft-icon name="fa-regular fa-gear text-white"></soft-icon>
  </button>
</div-->

<div class="grid 2xl:grid-cols-4 md:grid-cols-2 grid-cols-1 grid-rows-2 gap-4 w-full">
  @for (component of components$ | async; track component) {
    <ng-container *ngComponentOutlet="component"> </ng-container>
  }
</div>
